import React, { useEffect, useState } from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";
import ImageWithBasePath from "../../../../../core/img/imagewithbasebath";
import { Link } from "react-router-dom";

import {
  ChevronUp,
  // RotateCcw,
} from "feather-icons-react/build/IconComponents";
// import { setToogleHeader } from "../../../../../core/redux/action";
import Table from "../../../../../core/pagination/datatable";
import CommonFooter from "../../../../../core/common/footer/commonFooter";

import { Select, Spin } from "antd";
import dayjs from "dayjs";
import { BASE_CRM_URL } from "../../../../components/config/config";
import axios from "axios";
import Swal from "sweetalert2";
import jsPDF from "jspdf";
import autoTable from "jspdf-autotable";
import ExcelJS from "exceljs";
import { saveAs } from "file-saver";

const Estimates = () => {
  // const EstimateStatusColors = {
  //   Sent: "green",
  //   Pending: "orange",
  //   Declined: "red",
  //   Draft: "blue",
  //   Accepted: "success",
  //   Default: "default",
  // };

  const [estimatesStatusOptions, setEstimatesStatusOptions] = useState([]);
  const [exportLoading, setExportLoading] = useState(false);

  const getEstimatesStatuses = async () => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}estimates/GetEstimatesStatus`,
      );

      const data = await response.json();

      if (data.Status) {
        const options = data.ResultData.map((item) => ({
          value: item.id,
          label: item.name,
        }));

        setEstimatesStatusOptions(options);
      }
    } catch (error) {
      console.log(error);
    }
  };

  console.log(estimatesStatusOptions, "estimatesStatusOptions");

  const columns = [
    {
      title: "Estimate #",
      dataIndex: "Estimatenumber",

      render: (_, record) => {
        return (
          <Link to={`/crm/view/estimate`} state={{ record }}>
            <span className={``}>
              <i className="fa-regular fa-file-lines me-2"></i>
              {record.Estimatenumber}
            </span>
          </Link>
        );
      },
    },

    {
      title: "Customer",
      dataIndex: "ClientName",

      render: (_, record) => {
        return (
          <div className="d-flex align-items-start">
            <div className="ms-3">
              <div className="fw-semibold">
                {" "}
                <i className="fa-solid fa-building me-2 text-primary"></i>
                {record.ClientName || "N/A"}
              </div>

              <small className="text-muted">
                <i className="fa-solid fa-folder-open me-2"></i>
                {record.ProjectName || "N/A"}
              </small>
            </div>
          </div>
        );
      },
    },

    {
      title: "Amount",
      dataIndex: "total",

      render: (_, record) => (
        <>
          <div className="fw-semibold text-success">
            <i className="fa-solid fa-indian-rupee-sign me-2"></i>
            {record.total}
          </div>

          <small className="text-muted">
            <i className="fa-solid fa-percent me-2"></i>
            Tax : {record.total_tax}
          </small>
        </>
      ),
    },

    {
      title: "Created",
      dataIndex: "datecreated",

      render: (date) => {
        const created = dayjs(date);

        return (
          <div>
            <i className="fa-regular fa-calendar me-2 text-info"></i>
            {created.isValid() ? created.format("DD-MM-YYYY") : "-"}
          </div>
        );
      },
    },

    {
      title: "Expiry",
      dataIndex: "expirydate",

      render: (date) => {
        const expiry = dayjs(date);
        const days = expiry.diff(dayjs(), "day");

        return (
          <>
            <div>
              <i className="fa-regular fa-calendar-check me-2 text-primary"></i>
              {expiry.isValid() ? expiry.format("DD-MM-YYYY") : "-"}
            </div>

            <small
              className={
                days < 0
                  ? "text-danger"
                  : days <= 30
                    ? "text-warning"
                    : "text-success"
              }
            >
              <i className="fa-regular fa-clock me-2"></i>

              {days < 0
                ? `${Math.abs(days)} days overdue`
                : `${days} days left`}
            </small>
          </>
        );
      },
    },

    {
      title: "Status",
      dataIndex: "StatusName",

      render: (text, record) => {
        const getColor = (status) => {
          switch (status) {
            case "Draft":
              return "#6c757d";
            case "Sent":
              return "#0d6efd";

            case "Expired":
              return "#ffc107";
            case "Declined":
              return "#dc3545";
            case "Accepted":
              return "#198754";
            default:
              return "#6c757d";
          }
        };

        return (
          <Select
            value={
              estimatesStatusOptions.find(
                (item) => item.label === (text || "Draft"),
              )?.value
            }
            style={{ width: 120 }}
            options={estimatesStatusOptions}
            onChange={(value) => {
              updateEstimatesStatus(record.id, value);
            }}
            dropdownStyle={{ zIndex: 9999 }}
            optionRender={(option) => (
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  gap: 8,
                }}
              >
                <i
                  className="fa-solid fa-circle"
                  style={{
                    color: getColor(option.data.label),
                    fontSize: 10,
                  }}
                ></i>

                {option.data.label}
              </div>
            )}
            labelRender={({ value }) => {
              const status = estimatesStatusOptions.find(
                (x) => x.value === value,
              );

              return (
                <span>
                  <i
                    className="fa-solid fa-circle me-2"
                    style={{
                      color: getColor(status?.label),
                      fontSize: 10,
                    }}
                  ></i>
                  {status?.label}
                </span>
              );
            }}
          />
        );
      },
    },

    {
      title: "Action",
      dataIndex: "action",

      render: (_, record) => (
        <>
          {/* <Link
            className="action-set"
            to="#"
            data-bs-toggle="dropdown"
            aria-expanded="true"
          >
            <i className="fa fa-ellipsis-v btn border" />
          </Link>

          <ul className="dropdown-menu">
            <li>
              <Link
                to={`/crm/view/estimate`}
                state={{ record }}
                className="dropdown-item"
              >
                <Eye className="info-img text-info" />
                View
              </Link>
            </li>

            <li>
              <Link
                to={`/crm/update/estimate/${record.id}`}
                className="dropdown-item"
              >
                <Edit className="me-2 text-secondary" />
                Edit
              </Link>
            </li>
          </ul> */}

          <div className="action-table-data">
            <div className="edit-delete-action ">
              <Link
                title="Edit"
                to={`/crm/update/estimate/${record.id}`}
                className="text-primary me-2 p-2"
              >
                <i className="ti ti-pencil text-primary"></i>
              </Link>
            </div>
          </div>
        </>
      ),
    },
  ];

  const [estimateCounts, setEstimateCounts] = useState({
    TotalEstimates: 0,
    DraftEstimates: 0,
    SentEstimates: 0,
    ExpiredEstimates: 0,
    DeclinedEstimates: 0,
    AcceptedEstimates: 0,
  });

  const [estimates, setEstimates] = useState([]);
  const [selectedStatus, setSelectedStatus] = useState(0);

  const [estimateLoading, setEstimateLoading] = useState(false);

  const fetchEstimateCounts = async () => {
    try {
      // setCountLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}estimates/GetEstimateCounts`,
      );

      if (response.data?.Status && response.data?.ResultData?.length > 0) {
        setEstimateCounts(response.data.ResultData[0]);
      }
    } catch (error) {
      console.error("Get Estimate Counts Error:", error);
    }
    // finally {
    //   setCountLoading(false);
    // }
  };

  const fetchEstimates = async (status = 0) => {
    try {
      setEstimateLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}estimates/GetEstimates`,
        {
          params: {
            Status: status,
          },
        },
      );

      if (response.data?.Status) {
        setEstimates(response.data.ResultData || []);
      } else {
        setEstimates([]);
      }
    } catch (error) {
      console.error("Get Estimates Error:", error);
      setEstimates([]);
    } finally {
      setEstimateLoading(false);
    }
  };

  const updateEstimatesStatus = async (proposalId, statusId) => {
    try {
      const response = await fetch(
        `${BASE_CRM_URL}estimates/UpdateEstimatesStatus`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          body: JSON.stringify({
            id: proposalId,
            status: statusId,
          }),
        },
      );

      const data = await response.json();

      if (data.Status) {
        Swal.fire({
          icon: "success",
          title: "Success",
          text: data.Message,
          timer: 1200,
          showConfirmButton: false,
        });
         fetchEstimateCounts()
        fetchEstimates(0); // Reload your proposal list
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: data.Message,
        });
      }
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    fetchEstimateCounts();
    fetchEstimates(0);
    getEstimatesStatuses();
  }, []);

  const renderTooltip = (props) => (
    <Tooltip id="pdf-tooltip" {...props}>
      Pdf
    </Tooltip>
  );
  const renderExcelTooltip = (props) => (
    <Tooltip id="excel-tooltip" {...props}>
      Excel
    </Tooltip>
  );
  // const renderRefreshTooltip = (props) => (
  //   <Tooltip id="refresh-tooltip" {...props}>
  //     Refresh
  //   </Tooltip>
  // );
  // const renderFilterTooltip = (props) => (
  //   <Tooltip id="refresh-tooltip" {...props}>
  //     Filter
  //   </Tooltip>
  // );
  const renderCollapseTooltip = (props) => (
    <Tooltip id="refresh-tooltip" {...props}>
      Collapse
    </Tooltip>
  );

  const exportExcel = async () => {
    try {
      setExportLoading(true);

      const workbook = new ExcelJS.Workbook();
      const worksheet = workbook.addWorksheet("Leads");

      // Columns
      worksheet.columns = [
        { header: "Estimate#", key: "Estimatenumber", width: 25 },
        { header: "Company", key: "ClientName", width: 25 },
        { header: "Project", key: "ProjectName", width: 32 },
        { header: "Amount", key: "total", width: 18 },
        { header: "Created", key: "datecreated", width: 18 },
        { header: "Expiry", key: "expirydate", width: 18 },
        { header: "Status", key: "StatusName", width: 18 },
      ];

      // Add data
      estimates.forEach((estimate) => {
        worksheet.addRow({
          Estimatenumber: estimate.Estimatenumber ?? "",
          ClientName: estimate.ClientName ?? "",
          ProjectName: estimate.ProjectName ?? "",
          total: estimate.total ?? "",
          datecreated: estimate.datecreated ?? "",
          expirydate: estimate.expirydate ?? "",

          StatusName: estimate.StatusName || "N/A",
        });
      });

      // Header styling
      const headerRow = worksheet.getRow(1);

      headerRow.font = {
        bold: true,
      };

      headerRow.alignment = {
        horizontal: "center",
        vertical: "middle",
      };

      headerRow.height = 22;

      // Borders and alignment
      worksheet.eachRow((row) => {
        row.eachCell((cell) => {
          cell.border = {
            top: { style: "thin" },
            left: { style: "thin" },
            bottom: { style: "thin" },
            right: { style: "thin" },
          };

          cell.alignment = {
            vertical: "middle",
            wrapText: true,
          };
        });
      });

      // Footer
      worksheet.headerFooter.oddFooter =
        "&CGenerated by Pereco | Powered by perennialcode" + "&RPage &P of &N";

      // Repeat header when printing
      worksheet.printTitlesRow = "1:1";

      // Page setup
      worksheet.pageSetup = {
        orientation: "landscape",
        paperSize: 9,
        fitToPage: true,
        fitToWidth: 1,
        fitToHeight: 0,
      };

      // Generate Excel
      const buffer = await workbook.xlsx.writeBuffer();

      const blob = new Blob([buffer], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });

      saveAs(blob, "Estimate.xlsx");
    } catch (error) {
      console.error("Excel export error:", error);

      Swal.fire("Error", "Failed to generate Excel file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  const exportPDF = () => {
    try {
      setExportLoading(true);

      const doc = new jsPDF({
        orientation: "landscape",
        unit: "mm",
        format: "a4",
      });

      const generatedOn = new Date().toLocaleString("en-IN");

      const columns = [
        "Estimate#",
        "Company",
        "Project",
        "Amount",
        "Created",
        "Expiry",
        "Status",
      ];

      const rows = estimates.map((estimate) => [
        estimate.Estimatenumber ?? "",
        estimate.ClientName ?? "",
        estimate.ProjectName ?? "",

        estimate.total ?? "",
        estimate.datecreated ?? "",

        estimate.expirydate || "N/A",
        estimate.StatusName || "N/A",

        // estimate.dateadded
        //   ? new Date(estimate.dateadded).toLocaleString("en-IN")
        //   : "",
      ]);

      // Report title - top center
      doc.setFontSize(16);
      doc.setFont("helvetica", "bold");

      doc.text("Estimate Report", 148, 12, {
        align: "center",
      });

      // Generated On - top right
      doc.setFontSize(9);
      doc.setFont("helvetica", "normal");

      doc.text(`Generated On: ${generatedOn}`, 291, 12, {
        align: "right",
      });

      // Table
      autoTable(doc, {
        head: [columns],
        body: rows,

        startY: 20,

        margin: {
          top: 20,
          bottom: 18,
          left: 6,
          right: 6,
        },

        theme: "grid",

        styles: {
          fontSize: 6.5,
          cellPadding: 2,
          valign: "middle",
          overflow: "linebreak",
        },

        headStyles: {
          fontSize: 7,
          fontStyle: "bold",
        },

        showHead: "everyPage",

        didDrawPage: () => {
          // Footer center
          doc.setFontSize(8);
          doc.setFont("helvetica", "normal");

          doc.text("Generated by Pereco | Powered by perennialcode", 148, 200, {
            align: "center",
          });
        },
      });

      // Total pages
      const totalPages = doc.internal.getNumberOfPages();

      // Page X of Y
      for (let i = 1; i <= totalPages; i++) {
        doc.setPage(i);

        doc.setFontSize(8);
        doc.setFont("helvetica", "normal");

        doc.text(`Page ${i} of ${totalPages}`, 289, 200, {
          align: "right",
        });
      }

      doc.save("Estimate.pdf");
    } catch (error) {
      console.error("PDF export error:", error);

      Swal.fire("Error", "Failed to generate PDF file", "error");
    } finally {
      setExportLoading(false);
    }
  };

  return (
    <div className="page-wrapper">
      {exportLoading && (
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            zIndex: 1000,
            backgroundColor: "rgba(255, 255, 255, 0.8)",
          }}
        >
          <Spin size="large" tip="Processing..." />
        </div>
      )}
      <div className="content">
        <div className="page-header">
          <div className="add-item d-flex">
            <div className="page-title">
              <nav aria-label="breadcrumb">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/crm/Dashboard">
                      <i className="fas fa-home fa-lg" />
                    </Link>
                  </li>
                  <h4 className="breadcrumb-item " aria-current="page">
                    Estimates
                  </h4>
                </ol>
              </nav>
              <h6>Manage and add new Estimates here</h6>
            </div>
          </div>
          <ul className="table-top-head">
            <li>
              <OverlayTrigger placement="top" overlay={renderTooltip}>
                <Link onClick={exportPDF}>
                  <ImageWithBasePath src="assets/img/icons/pdf.svg" alt="img" />
                </Link>
              </OverlayTrigger>
            </li>
            <li>
              <OverlayTrigger placement="top" overlay={renderExcelTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  onClick={exportExcel}
                >
                  <ImageWithBasePath
                    src="assets/img/icons/excel.svg"
                    alt="img"
                  />
                </Link>
              </OverlayTrigger>
            </li>

            {/* <li>
              <OverlayTrigger placement="top" overlay={renderRefreshTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <RotateCcw />
                </Link>
              </OverlayTrigger>
            </li> */}
            <li>
              <OverlayTrigger placement="top" overlay={renderCollapseTooltip}>
                <Link
                  data-bs-toggle="tooltip"
                  data-bs-placement="top"
                  id="collapse-header"
                  // className={data ? "active" : ""}
                  onClick={(e) => {
                    e.preventDefault();
                    // dispatch(setToogleHeader(!data));
                  }}
                >
                  <ChevronUp />
                </Link>
              </OverlayTrigger>
            </li>
            {/* <li>
              <OverlayTrigger placement="top" overlay={renderFilterTooltip}>
                <Link data-bs-toggle="tooltip" data-bs-placement="top">
                  <Filter />
                </Link>
              </OverlayTrigger>
            </li> */}
          </ul>
          <div className="page-btn">
            <Link to="/crm/add/estimate" className="btn btn-success btn-sm">
              <i className="ti ti-circle-plus fs-4 "> </i>
            </Link>
          </div>
        </div>
        <div className="row g-3">
          {/* Draft */}
          <div className="col-12 col-sm-6 col-xl d-flex">
            <div
              className={`card flex-fill shadow-sm ${
                selectedStatus === 1 ? "border-primary" : ""
              }`}
              onClick={() => {
                setSelectedStatus(1);
                fetchEstimates(1);
              }}
              style={{ cursor: "pointer" }}
            >
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3 ">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">
                    {estimateCounts.DraftEstimates || 0}/
                    {estimateCounts.TotalEstimates || 0}
                  </h4>
                  <p className="mb-0 fw-semibold">Draft</p>
                </div>

                <div
                  className="rounded-circle bg-info bg-opacity-10 d-flex align-items-center justify-content-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-file-lines text-primary fs-4"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Sent */}
          <div className="col-12 col-sm-6 col-xl d-flex">
            <div
              className={`card flex-fill shadow-sm ${
                selectedStatus === 2 ? "border-primary" : ""
              }`}
              onClick={() => {
                setSelectedStatus(2);
                fetchEstimates(2);
              }}
              style={{ cursor: "pointer" }}
            >
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">
                    {estimateCounts.SentEstimates || 0}/
                    {estimateCounts.TotalEstimates || 0}
                  </h4>
                  <p className="mb-0 fw-semibold">Sent</p>
                </div>

                <div
                  className="rounded-circle bg-info bg-opacity-10 d-flex align-items-center justify-content-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-paper-plane text-info fs-4"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Expired */}
          <div className="col-12 col-sm-6 col-xl d-flex">
            <div
              className={`card flex-fill shadow-sm ${
                selectedStatus === 3 ? "border-primary" : ""
              }`}
              onClick={() => {
                setSelectedStatus(3);
                fetchEstimates(3);
              }}
              style={{ cursor: "pointer" }}
            >
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">
                    {estimateCounts.ExpiredEstimates || 0}/
                    {estimateCounts.TotalEstimates || 0}
                  </h4>
                  <p className="mb-0 fw-semibold">Expired</p>
                </div>

                <div
                  className="rounded-circle bg-warning bg-opacity-10 d-flex align-items-center justify-content-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-hourglass-end text-warning fs-4"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Declined */}
          <div className="col-12 col-sm-6 col-xl d-flex">
            <div
              className={`card flex-fill shadow-sm ${
                selectedStatus === 4 ? "border-primary" : ""
              }`}
              onClick={() => {
                setSelectedStatus(4);
                fetchEstimates(4);
              }}
              style={{ cursor: "pointer" }}
            >
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">
                    {estimateCounts.DeclinedEstimates || 0}/
                    {estimateCounts.TotalEstimates || 0}
                  </h4>
                  <p className="mb-0 fw-semibold">Declined</p>
                </div>

                <div
                  className="rounded-circle bg-danger bg-opacity-10 d-flex align-items-center justify-content-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-circle-xmark text-danger fs-4"></i>
                </div>
              </div>
            </div>
          </div>

          {/* Accepted */}
          <div className="col-12 col-sm-6 col-xl d-flex">
            <div
              className={`card flex-fill shadow-sm ${
                selectedStatus === 5 ? "border-primary" : ""
              }`}
              onClick={() => {
                setSelectedStatus(5);
                fetchEstimates(5);
              }}
              style={{ cursor: "pointer" }}
            >
              <div className="card-body d-flex justify-content-between align-items-center py-2 px-3">
                <div className="d-flex align-items-center gap-2 text-nowrap">
                  <h4 className="mb-0 fw-bold">
                    {estimateCounts.AcceptedEstimates || 0}/
                    {estimateCounts.TotalEstimates || 0}
                  </h4>
                  <p className="mb-0 fw-semibold">Accepted</p>
                </div>

                <div
                  className="rounded-circle bg-success bg-opacity-10 d-flex align-items-center justify-content-center"
                  style={{ width: 45, height: 45 }}
                >
                  <i className="fa-solid fa-circle-check text-success fs-4"></i>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* /product list */}
        <div className="card table-list-card">
          <div className="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3">
            <div className="search-set"></div>
            <div className="d-flex table-dropdown my-xl-auto right-content align-items-center flex-wrap row-gap-3">
              <div className="me-2">
                <Select
                  value={selectedStatus}
                  onChange={(value) => {
                    setSelectedStatus(value);
                    fetchEstimates(value);
                  }}
                  options={[
                    { value: 0, label: "All" },
                    { value: 1, label: "Draft" },
                    { value: 2, label: "Sent" },
                    { value: 3, label: "Expired" },
                    { value: 4, label: "Declined" },
                    { value: 5, label: "Accepted" },
                  ]}
                  style={{ width: 130 }}
                  // suffixIcon={<i className="ti ti-filter" />}
                />
              </div>
            </div>
          </div>
          <div className="card-body">
            <div className="table-responsive">
              {estimateLoading ? (
                <div
                  style={{
                    display: "flex",
                    justifyContent: "center",
                    alignItems: "center",
                    height: "250px", // adjust height if needed
                  }}
                >
                  <Spin size="large" />
                </div>
              ) : (
                <Table columns={columns} dataSource={estimates} />
              )}
            </div>
          </div>
        </div>
        <CommonFooter />
      </div>
    </div>
  );
};

export default Estimates;
